module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/payrollSubmissions/Submission.ejs -->\n<td>'+
((__t=( model.getCompany().get('companyName') ))==null?'':_.escape(__t))+
'</td>\n<td>\n    <div>\n        '+
((__t=( statusText ))==null?'':_.escape(__t))+
'\n    </div>\n    <div class="progress">\n        ';
 payrollProgress = (((model.get('status') - 2) * 100) / 7).toFixed(0) 
__p+='\n        <div class="js-payroll-progress progress-bar\n            '+
((__t=(
                model.get('status') <= 3 ? 'progress-bar-danger' :
                model.get('status') <= 5 ? 'progress-bar-warning' :
                model.get('status') <= 8 ? 'progress-bar-info' :
                    'progress-bar-primary'
            ))==null?'':_.escape(__t))+
'" role="progressbar" style="width:'+
((__t=( payrollProgress ))==null?'':_.escape(__t))+
'%">\n            <span>'+
((__t=( payrollProgress ))==null?'':_.escape(__t))+
'%</span>\n        </div>\n    </div>\n</td>\n<td class="td-action">\n    ';
 /* We don't show the cancel button for statuses 1 and 2 because they
        * have a special markup due to a datepicker and for status 8 because
        * it means the payroll is completed. FIXME we need to fix the template
        * to avoid this suckiness
        */ 
__p+='\n    ';
 if (!_.contains([3, 9], model.get('status'))) { 
__p+='\n        <button type="button" class="btn btn-danger js-cancel pull-right">\n            Cancel\n        </button>\n    ';
 } 
__p+='\n\n    ';
 if (model.get('status') === 9) { 
__p+='\n        <button type="button" class="btn btn-danger btn-outline js-revert\n            pull-right">\n            Revert\n        </button>\n    ';
 } 
__p+='\n\n    ';
 if (model.get('status') === 3) { 
__p+='\n        <div class="row">\n            <div class="col-md-9 col-lg-8">\n                <div class="form-group form-group-date"\n                    style="display:inline-block;">\n                    <label class="font-noraml">Cheque Pickup Date:</label>\n                    <div class="pickup-date input-group date"\n                        data-date-format="dd/mm/yyyy"\n                        style="max-width:200px">\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-white">\n                                <i class="fa fa-calendar"></i>\n                            </button>\n                        </span>\n                        <input type="text" class="form-control" value="">\n                    </div>\n                </div>\n                <button type="button" class="btn btn-success\n                    js-confirm-pickup" style="position:relative; top: 31px;">\n                    Confirm Pick Up\n                </button>\n            </div>\n            <div class="col-md-3 col-lg-4">\n                <button type="button" class="btn btn-danger js-cancel\n                    btn-confirm-pickup pull-right">\n                    Cancel\n                </button>\n            </div>\n        </div>\n\n    ';
 } else if (model.get('status') === 4) { 
__p+='\n        <button type="button" class="btn btn-success js-received-payment">\n            Received Payment\n        </button>\n\n    ';
 } else if (model.get('status') === 5) { 
__p+='\n        <button class="btn btn-success js-generate-forms">\n            Generate Forms\n        </button>\n\n        <button type="button" class="btn btn-success js-awaiting-signatures">\n            Forms - Awaiting Signatures\n        </button>\n\n        <div class="files-list js-attachments"></div>\n    ';
 } else if (model.get('status') === 6) { 
__p+='\n        <button type="button" class="btn btn-success js-awaiting-submission">\n            Forms - Awaiting Submission to Government\n        </button>\n\n    ';
 } else if (model.get('status') === 7) { 
__p+='\n        <button type="button" class="btn btn-success js-submitted-to-govt">\n            Forms - Submitted to Government\n        </button>\n\n    ';
 } else if (model.get('status') === 8) { 
__p+='\n        <div class="btn-group js-upload-files">\n            <button class="btn btn-success dropdown-toggle"\n                data-toggle="dropdown">\n                Upload Files\n                <span class="caret"></span>\n            </button>\n            <ul class="dropdown-menu">\n                ';
 files = {
                    'pcb tax-receipt':      'PCB Receipt',
                    'socso tax-receipt':    'SOCSO Receipt',
                    'form socso pdf final': '8A SOCSO Form (Final)',
                    'form mtd pdf final':   'CP39 PCB Form (Final)'
                } 
__p+='\n                ';
 _.each(_.keys(files), function(tags) { 
__p+='\n                    <li>\n                        <label>\n                            <input class="hide js-upload-file"\n                                data-tags="'+
((__t=( tags ))==null?'':_.escape(__t))+
'"\n                                data-description="'+
((__t=( files[tags] ))==null?'':_.escape(__t))+
'"\n                                type="file" name="file">\n                                '+
((__t=( files[tags] ))==null?'':_.escape(__t))+
'\n                        </label>\n                    </li>\n                ';
 }) 
__p+='\n            </ul>\n        </div>\n\n        <button type="button" class="btn btn-success js-notify-company">\n            Forms - Uploaded - Notify Company\n        </button>\n\n        <div class="files-list js-attachments"></div>\n    ';
 } 
__p+='\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/payrollSubmissions/Submission.ejs
// module id = 653
// module chunks = 1